import { List } from "immutable";
import * as React from "react";
import Die from "../die";
import WholeDieDisplay from "./wholeDieDisplay";
import State from "../model";
import { Dispatch } from "redux";
import { AppAction } from "../actions";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import OddsDisplay from "./oddsDisplay";
import { StateWithHistory } from "redux-undo";

interface DieSummaryProps {
    dice: List<Die>;
    selectedSeven: List<number>;
    currentRoll: [number, number, number, number, number];    
}

class DieSummaryDisplay extends React.Component<DieSummaryProps, {}> {
    public render(): JSX.Element {
        return <Row>
            <Col xs={2}><OddsDisplay /></Col>
            {this.props.dice.map((die, i) => <WholeDieDisplay key={i} die={die} index={i} selected={(this.props.selectedSeven == undefined) ? false : this.props.selectedSeven.indexOf(i) > -1} currentRoll={(this.props.currentRoll == undefined) ? -1 : this.props.currentRoll[i]} />)}
        </Row>;
    }
}

const mapStateToProps = (state: StateWithHistory<State>, ownProps: {}) => {
    return {
        dice: state.present.dice,
        selectedSeven: state.present.selectedSeven,
        currentRoll: state.present.currentRoll
    };
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(DieSummaryDisplay);
    